<template>
  <div class="h-100">
    <main role="main" class="h-100">
        <common-master-table
          primary-key="taskTypeSerialId"
          table-no="mstTaskType"
          table-api="master/task-type"
          ref="commonMasterTable"
          :editable="editableMixin.taskType"
          :addable="editableMixin.taskType"
          :mapping-no="`ie-task-type`"
          :hideButtonImportCsv="true"
          socket-entity="TASK_TYPE_MST_SOCKET"
        />
    </main>
  </div>
</template>

<script>
import CommonMasterTable from '../custom-components/CommonMasterTable'
import RouterUtils from '../../_helpers/router.util'
export default {
  components: {
    // コンポーネント分割化
    CommonMasterTable
  },
  data() {
    return {
      removeKeys: [],
      updateQueryStr: ''
    }
  },
  beforeRouteUpdate(to, from) {
    if (to.query && to.query.hasOwnProperty('limit') && Object.keys(to.query).length === 1) {
      RouterUtils.correctTableRowsLimitParam(to.query)
      this.$refs.commonMasterTable.initData()
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/mst-tables/TaskTypeMaster.vue